import React from 'react'
import './css/services.css'

export default function ServicesCounter() {
  return (
    <>
    <div className="counter-main-inner">
      <div className="container counter-main">
        
            <div className="row row-cols-5 counter">
                <div className="col inner-counter">
                    <div className="counter-contain">
                    <h1>6+</h1>
                    <div class="rotating-circle"></div>
                    </div>
                    <div className="counter-text">
                        <p>Years of Expertise</p>
                    </div>

                </div>
                <div className="col inner-counter">
                    <div className="counter-contain">
                        <h1>50+</h1>
                    </div>
                    <div className="counter-text">
                        <p>Successful Projects</p>
                    </div>

                </div>
                <div className="col inner-counter">
                    <div className="counter-contain">
                        <h1>25+</h1>
                    </div>
                    <div className="counter-text">
                        <p>Global Partners
</p>
                    </div>

                </div>
                <div className="col inner-counter">
                    <div className="counter-contain">
                        <h1>100%</h1>
                    </div>
                    <div className="counter-text">
                        <p>Client Satisfaction
</p>
                    </div>

                </div>
                <div className="col inner-counter">
                    <div className="counter-contain">
                        <h1>30+</h1>
                    </div>
                    <div className="counter-text">
                        <p>Strategic Alliances

</p>
                    </div>

                </div>

            </div>

        </div>
        

      </div>
    </>
  )
}
